import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";

import {
  getCustomerMasterlist,
  saveCustomerDetails,
  updateCustomerDetails,
  getBroadcastMasterReq,
} from "../../../../apiservicescall/api";

import Table from "@mui/material/Table";
import { Link } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Col, Badge, Card, Row, Button, Container } from "react-bootstrap";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { Form, FormGroup, Label, Input } from "reactstrap";
import swal from "sweetalert";
import TableView from "./Tableview";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
// import { faXmark } from '@fortawesome/pro-solid-svg-icons';

const Campaign = () => {
  const [customerList, setCustomerList] = useState([
    {
      TemplateName: "Template 1 ",
      TemplateId: "1",
      logdetails: [
        {
          TemplateName: "Template 1 ",
          TemplateId: "1",
          CustomerName: "narayanan",
          CustomerMobile: "9978455612",
          emailId: "Thanks for order",
          status: "done",
          SendDate: "05/02/2024",
        },
        {
          TemplateName: "Template 1 ",
          TemplateId: "1",
          CustomerName: "santhos",
          CustomerMobile: "9978455612",
          emailId: "Thanks for order",
          status: "done",
          SendDate: "05/02/2024",
        },
      ],
    },
    {
      TemplateName: "Template 2 ",
      TemplateId: "2",
      logdetails: [
        {
          TemplateName: "Template 2 ",
          TemplateId: "2",
          CustomerName: "Rahul",
          CustomerMobile: "9978455612",
          emailId: "Thanks for order",
          status: "done",
          SendDate: "05/02/2024",
        },
        {
          TemplateName: "Template 2 ",
          TemplateId: "2",
          CustomerName: "Ram",
          CustomerMobile: "9978455612",
          emailId: "Thanks for order",
          status: "done",
          SendDate: "05/02/2024",
        },
      ],
    },
    {
      TemplateName: "Template 3 ",
      TemplateId: "3",
      logdetails: [
        {
          TemplateName: "Template 3 ",
          TemplateId: "3",
          CustomerName: "Kumar",
          CustomerMobile: "9978455612",
          emailId: "Thanks for order",
          status: "done",
          SendDate: "05/02/2024",
        },
        {
          TemplateName: "Template 3 ",
          TemplateId: "3",
          CustomerName: "vijay",
          CustomerMobile: "9475755612",
          emailId: "Thanks for order",
          status: "done",
          SendDate: "05/02/2024",
        },
      ],
    },
  ]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [logdata, setLogdata] = useState([]);
  const [tableView, setTableView] = useState(false);

  const [broadcastlist, setBroadcastlist] = useState([]);
  useEffect(() => {
    // getcustomerlist();
    getBroadcastmasterlist();
  }, []);

  const getcustomerlist = async () => {
    let customerList = await getCustomerMasterlist();

    let customerlistvalue = customerList?.data.data || [];
    // setCustomerList(customerlistvalue);

    let totpage = Math.ceil(customerlistvalue.length / itemsPerPage);

    setTotalPages(totpage);

    let titem = customerlistvalue.length;
    setTotalItems(titem);
  };

  const getBroadcastmasterlist = async () => {
    let getlist = await getBroadcastMasterReq();

    let getlistvalue = getlist?.data.data || [];
    console.log("getlistvalue", getlistvalue);

    setBroadcastlist(getlistvalue);
  };

  const opnAddNewUserModal = (e) => {
    //e.preventDefault();
    // setLargeModal(!largeModal);
    // setIsview(false);
    // setIsedit(false);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };

  const onDetailsview = (data) => {
    // console.log('datadata', data.rowData);
    let row = data.rowData;

    let logdata = row?.[2];
    // let redata =  logdata?.[0];
    //console.log('first1232', redata);
    setTableView(true);
    setLogdata(logdata);
  };

  const options = {
    filter: false,
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    filterType: "dropdown",
    selectableRows: false,
    responsive: "stacked",
    // count: totalItems,
    search: false,
    // textLabels: {
    // 	body: {
    // 		noMatch: labelmessage
    // 	},
    // },
    fixedHeader: true,
    tableBodyHeight: "425px",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    // onColumnSortChange: this.customSort,
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },

    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterVal,
      filterOptions,
      changedColumnIndex,
      displayData
    ) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        this.handleFilterSubmit(newFilters);
      }
    },

    onSearchChange: (searchValue) => this.customSearch(searchValue),
    // table's internal filterList
    confirmFilters: true,

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => this.handleFilterSubmit(applyNewFilters)}
          >
            Apply Filters
          </Button>
        </div>
      );
    },

    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {},

    onFilterDialogOpen: () => {},
    onFilterDialogClose: () => {},
    customToolbar: () => {
      return (
        <>
          {
            <>
              <Link
                to={`/Campaign_Service`}
                className="caret btn-sm mr-10"
                style={{
                  backgroundColor: "#008000",
                  color: "white",
                  width: "10px",
                  height: "20px",
                }}
              >
                 Create BroadCast <i className="zmdi zmdi-lus"> </i>{" "}
              </Link>
              {/* ) : (
                <a
                  href="#"
                  style={{
                    backgroundColor: "#008000",
                    color: "white",
                    fontSize: "medium",
                  }}
                  onClick={(e) => {
                    opnAddNewUserModal(e);
                    setCustomerDetail({});
                  }}
                  className="caret btn-sm mr-10"
                >
                  Add <i className="zmdi zmdi-lus"></i>
                </a>
              )} */}
            </>
          }
        </>
      );
    },
    //Search Query for list

    // customSearchRender: (searchText, handleSearch, hideSearch, options) => {
    //
    //   return (
    // 	<>
    // 	  <CustomSearchRender
    // 		debounceWait={500}
    // 		searchText={searchText}
    // 		onSearch={this.handleSearch}
    // 		onHide={hideSearch}
    // 		options={options}
    // 		onClear={this.handleClear}
    // 		searchField={this.state.searchField}
    // 		searchValue={this.state.searchValue}
    // 		fields={this.state.fields}
    // 		handleFieldChange={this.handleFieldChange}
    // 	  />
    // 	</>
    //   );
    // },
  };

  const columns = [
    {
      name: "templateName",
      label: "Template Name",
      options: {
        filter: false,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "templateId",
      label: "Template ID",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "headerTypeName",
      label: "Message Type",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    // {
    //   name: "headerUrl",
    //   label: "HeaderUrl",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     customFilterListOptions: { render: (v) => `UID: ${v}` },
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",
    //   },
    // },

    // logdetails:[{
    //   custMobile: "8978455612",
    //   emailId: "Thanks for order",},
    //   {
    //     custMobile: "8978455612",
    //     emailId: "Thanks for order",
    //   }
    //   ]

    // {
    //   name: "logdetails",
    //   label: "Log Details",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (summary, tableMeta, updateValue) => {
    //       return (
    //         <div className="list-action">
    //           <span style={{ color: "black" }} className="icon-top-left">
    //             <Link
    //               className="btn btn-primary shadow btn-xs sharp me-2"
    //               onClick={() => {
    //                  onDetailsview(tableMeta);
    //               }}
    //               style={{ background: "#008000" }}
    //             >
    //               <i class="bi bi-files"></i>
    //             </Link>
    //           </span>
    //         </div>
    //       );
    //     },
    //   },
    // },
  ];

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  const getSteps = () => {
    return ["Channel", "Campaign Mode", "Target", "Content", "Schedule"];
  };

  const totalSteps = () => {
    return this.getSteps().length;
  };

  return (
    <RctCollapsibleCard fullBlock>
      <MuiThemeProvider theme={themeTable}>
        {customerList && (
          <MUIDataTable
            title={"Broadcast List"}
            data={broadcastlist}
            columns={columns}
            options={options}
            columOrder={columns}
          />
        )}
      </MuiThemeProvider>
      <Modal
        isOpen={tableView}
        // toggle={() => onClose()}
        style={{
          maxWidth: tableView && "900px",
        }}
        backdrop="static"
      >
        <ModalHeader>{tableView && "Template Details "}</ModalHeader>
        <ModalBody>
          {tableView && (
            <div>
              <TableView data1={logdata} />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          {tableView && (
            <>
              {/* {isView === false && isedit === false && (
                <Button
                  variant="primary"
                  className={!formIsValid ? "btn-disabled" : "btn-primary"}
                  disabled={!formIsValid}
                  onClick={() => {
                    
                  }}
                >
                  Submit
                </Button>
              )} */}

              <Button
                variant="secondary"
                onClick={() => {
                  setTableView(false);
                }}
              >
                Cancel
              </Button>
            </>
          )}
        </ModalFooter>
      </Modal>
    </RctCollapsibleCard>
  );
};

export default Campaign;
